<template>
    <div>{{ props.params.getMessage() }}</div>
</template>

<script setup lang="ts">
const props = defineProps({
    params: {
        type: Object as () => { getMessage: Function },
        default: Object as () => {getMessage: () => 'Ingen rader å vise'}
    }
})

</script>

<style scoped>

</style>